<script>
import GenreGridTile from '@components/genre/genre-grid-tile'

export default {
    name: 'GenreGridBlock',
    components: {
        GenreGridTile,
    },
    props: {
        genres: {
            type: Array,
            default: () => [],
        },
        padded: {
            type: Boolean,
            default: false,
        },
        followedGenreIds: {
            type: Array,
            default: () => [],
        },
        hasOptions: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        followedGenreIdsSet() {
            return new Set(this.followedGenreIds)
        },
    },
    methods: {
        handleToggleFollow(genre) {
            this.$emit('toggle-follow', genre)
        },
    },
}
</script>

<template>
    <div
        class="block"
        :class="{
            padded,
        }"
    >
        <GenreGridTile
            v-for="(genre, index) in genres"
            :key="'genre-' + genre.id"
            :genre="genre"
            :index="index"
            :is-following="followedGenreIdsSet.has(genre.id)"
            :has-options="hasOptions"
            class="tile"
            @toggle-follow="handleToggleFollow"
        />
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.block {
    display: grid;
    gap: $s-xl;

    &.padded {
        @include sidePadding;
    }
}

@include tablet {
    .block {
        grid-template-columns: repeat(2, 1fr);
    }
}

@include desktop {
    .block {
        grid-template-columns: repeat(3, 1fr);
    }
}

@include widescreen {
    .block {
        grid-template-columns: repeat(4, 1fr);
    }
}
</style>
